module.exports = __webpack_public_path__ + "static/lamp-zoom-25b63d6403d1e503f2e04f9ff2638af5.jpg";